import { Link, NavLink } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { FileArchive, Shield, Users } from "lucide-react";
import { useMe } from "@/lib/api";

const navCls = ({ isActive }) =>
  `h-9 px-2 sm:px-3 whitespace-nowrap rounded-md text-sm flex items-center gap-1.5 transition-colors ${isActive ? "bg-slate-100 text-slate-900 font-semibold" : "text-slate-600 hover:bg-slate-100"}`;

const TeamLink = () => {
  const { data } = useMe();
  if (!data?.firm) return null;
  return <NavLink to="/team" className={navCls} data-testid="nav-team"><Users size={14} /> Team</NavLink>;
};

const AdminLink = () => {
  const { data } = useMe();
  if (data?.role !== "admin") return null;
  return <NavLink to="/admin" className={navCls} data-testid="nav-admin"><Shield size={14} /> Admin</NavLink>;
};

export default function Header() {
  return (
    <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="app-brand">
          <div className="w-9 h-9 rounded-md bg-[#1E293B] text-amber-400 grid place-items-center">
            <FileArchive size={18} />
          </div>
          <div>
            <div className="hidden min-[400px]:block font-heading font-bold text-lg leading-none tracking-tight">DocketZip</div>
            <div className="hidden sm:block text-[11px] uppercase tracking-[0.18em] text-slate-500 mt-1">NYSCEF batch PDF downloader</div>
          </div>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <Show when="signed-in">
            <NavLink to="/" end className={navCls} data-testid="nav-dashboard">Dashboard</NavLink>
          </Show>
          <NavLink to="/pricing" className={navCls} data-testid="nav-pricing">Pricing</NavLink>
          <Show when="signed-in">
            <TeamLink />
            <AdminLink />
            <div className="ml-1" data-testid="user-menu"><UserButton /></div>
          </Show>
          <Show when="signed-out">
            <Link to="/sign-in" className="h-9 px-2 sm:px-3 whitespace-nowrap rounded-md text-sm text-slate-700 hover:bg-slate-100 flex items-center" data-testid="nav-sign-in">Sign in</Link>
            <Link to="/sign-up" className="h-9 px-3 sm:px-4 whitespace-nowrap rounded-md bg-[#1E293B] text-white text-sm font-medium hover:bg-blue-600 transition-colors flex items-center" data-testid="nav-sign-up">Get started</Link>
          </Show>
        </nav>
      </div>
    </header>
  );
}
